import * as React from 'react';
import { useField } from 'formik';
import styled from 'styled-components';

import EntityCreateShareFormGroup from 'components/permissions/EntityCreateShareFormGroup';
import type { EntitySharePayload } from 'actions/permissions/EntityShareActions';

const StyledShareSection = styled.div`
  & > div {
    width: 100%;
  }

  width: 100%;
`;

type Props = {
  field: any & { value: EntitySharePayload };
  description?: string;
  entityType?: string;
};

function ShareFormField({ field, description = undefined, entityType = undefined }: Props) {
  const [{ value }, _m, { setValue, setTouched }] = useField({ name: field.name });

  const onSetEntityShare = React.useCallback(
    (sharePayload: EntitySharePayload) => {
      setValue(sharePayload);
      setTouched(true);
    },
    [setTouched, setValue],
  );

  return (
    <StyledShareSection>
      <EntityCreateShareFormGroup
        description={description}
        entityType={entityType}
        onSetEntityShare={onSetEntityShare}
        defaultSharePayload={value}
      />
    </StyledShareSection>
  );
}

export default ShareFormField;
